import { render, staticRenderFns } from "./UserManualButton.vue?vue&type=template&id=53758278&scoped=true"
import script from "./UserManualButton.vue?vue&type=script&lang=js"
export * from "./UserManualButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53758278",
  null
  
)

export default component.exports